import React from "react";
import classNames from "classnames";
import { TextInput } from "@common/textInput";
import { Props } from "./types";
import styles from "./styles.scss";

function TextForm({
  value,
  readOnly,
  disabled,
  flexible,
  edit,
  submit,
}: Props) {
  return readOnly ? (
    <div className={classNames(styles.textForm, styles.readOnly)}>
      <p className={styles.input}>{value}</p>
    </div>
  ) : (
    <form
      className={styles.textForm}
      onSubmit={(e) => {
        e.preventDefault();
        submit(value);
      }}
    >
      <TextInput
        value={value}
        className={classNames(styles.input, {
          [styles.disabled]: disabled,
          [styles.multiline]: flexible,
        })}
        placeholder="-"
        isDisabled={disabled}
        isMultiline={flexible}
        input={edit}
        blur={() => submit(value)}
      />
    </form>
  );
}

export { TextForm };
